<template>
	<b-modal
		:hide-footer="true"
		:title="$t('Upload de arquivos')"
		centered
		id="upload"
	>
		<div class="row px-3">
			<div class="col-12 alert alert-danger" v-if="error">
				{{ error }}
			</div>
			<div class="row col-12 px-3 d-flex justify-content-center" v-if="loading">
				<load mode="table" />
				<h5 class="my-3">
					Enviando <b>{{ files.length }}</b> arquivo(s)
				</h5>
			</div>
			<form v-else @submit.prevent="submit" ref="addItem" class="col-12 px-0">
				<div class="row">
					<form-file
						@submit="submitFile"
						multiple
						btn-text="Iniciar"
						:progress="progressCompleted"
					/>
				</div>
				<div class="row px-2 d-flex justify-content-end">
					<button class="btn btn-primary btn-sm" @click="submit">Enviar</button>
				</div>
			</form>
		</div>
	</b-modal>
</template>
<script>
export default {
	props: ["path", "pathRoot", "item"],
	data() {
		return {
			nome: "",
			error: "",
			loading: false,
			files: "",
			progressCompleted: 0,
		};
	},
	methods: {
		submitFile(files) {
			this.files = files;
		},
		submit() {
			this.loading = true;
			this.error = null;
			let formData = new FormData();

			if (this.files.length > 0 && this.files.length != undefined) {
				for (const i of Object.keys(this.files)) {
					formData.append("files[]", this.files[i]);
				}
			} else {
				formData.append("files", this.files);
			}

			formData.append("caminho", this.path);
			formData.append("caminho_root", this.pathRoot);
			formData.append("id", this.item.id);

			axios
				.post(`api/dashboard/documento/upload`, formData, {
					header: { "Content-Type": "multipart/form-data" },
					onUploadProgress: (event) => {
						let progress = Math.round((event.loaded * 100) / event.total);
						this.progressCompleted = progress;
					},
				})
				.then((response) => {
					const data = response.data;
					const status = response.status;

					if (data.success === true && status === 200) {
						swal.fire(
							"Sucesso",
							data.message || `${data.total || 1} arquivo(s) enviado(s) com sucesso!`,
							"success"
						);
						this.$emit("upload-completed", this.path);
						this.error = null;
						this.nome = "";
					}
					// Sucesso parcial (207 Multi-Status, alguns falharam)
					else if (status === 207 && data.uploaded_files && data.uploaded_files.length > 0) {
						let errorMessages = data.errors.map(err => 
							`${err.file}: ${err.error}`
						).join('\n');
						
						swal.fire(
							"Parcial",
							`${data.uploaded_files.length} arquivo(s) enviado(s) com sucesso.\n\n${errorMessages}`,
							"warning"
						);
						this.$emit("upload-completed", this.path);
						this.error = null;
					}
					// Falha completa (400 Bad Request, nenhum arquivo enviado)
					else if (data.success === false && data.message) {
						this.error = data.message;
						let errorMessages = data.errors && data.errors.length > 0
							? data.errors.map(err => `${err.file}: ${err.error}`).join('\n')
							: this.error;
						swal.fire("Erro", errorMessages, "error");
					}
					// Fallback para outras respostas
					else {
						this.error = 'Resposta inesperada do servidor';
						swal.fire("Erro", this.error, "error");
					}
				})
				.catch((error) => {
					const response = error.response;
					if (response && response.data) {
						this.error = response.data.message || 'Erro ao fazer upload';
					} else {
						this.error = 'Erro ao fazer upload dos arquivos';
					}
					swal.fire("Erro", this.error, "error");
				})
				.finally(() => {
					this.progressCompleted = 0;
					this.files = [];
					this.$bvModal.hide("upload");
					this.loading = false;
				});
		},
	},
};
</script>
